export const colors = {
  primary: '#2563eb',
  secondary: '#475569',
  success: '#059669',
  danger: '#dc2626',
  warning: '#d97706',
  info: '#0891b2',
  error: '#dc2626',
  tool1: '#1d4ed8',
  tool2: '#047857',
  tool3: '#6d28d9',
  background: '#f8fafc',
  surface: '#ffffff',
  border: '#e2e8f0',
  text: {
    primary: '#1e293b',
    secondary: '#64748b',
    light: '#94a3b8'
  }
}; 